function TableHead({ children, ...rest }) {
  return <thead {...rest}>{children}</thead>;
}

export default TableHead;
